// services/exam.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, shareReplay } from 'rxjs';
import { environment } from '@tsin-env/environment';
import { ExamType } from '@tsin-core/entities';
import { IExam, IExamCreate, IExamList, IExamPool } from '@tsin-core/models/exam.model';

const EXAM_URL = `${environment.apiUrl}/exams`;
const EXAMINER_URL = `${environment.apiUrl}/examiner`;
const APPLICATION_URL = `${environment.apiUrl}/applications/exam/`;
const EXAMS_GUESTS_API_URL = `${environment.apiUrl}user/guests`;
const NOT_REGISTERED_USERS_API_URL = `${environment.apiUrl}user/not-registered-users`;
// /api/applications/exam/{id}
// 'https://vj2np9pdd6.us-east-1.awsapprunner.com/api/exams',

@Injectable({
  providedIn: 'root',
})
export class ExamService {
  constructor(private http: HttpClient) { }

  //   getApplicationByExamId(id: string) {
  //     return this.http.get<any>(
  //       `${APPLICATION_URL}${'678e2e3931cb12670f839463'}`
  //     );
  //   }

  getExams(
    examType: ExamType,
    time: 'upcoming' | 'past' | 'all'
  ): Observable<{ data: IExamList[] }> {
    return this.http.get<{ data: IExamList[] }>(`${EXAM_URL}`, {
      params: { type: examType, time: time },
    });
  }

  getSingleExam(
    examId: string
  ): Observable<{ data: IExamList }> {
    // console.log('getExams', examType);
    return this.http.get<{ data: IExamList }>(`${EXAM_URL}/single/${examId}`);
  }

  addExam(exam: Omit<IExamCreate, 'id'>): Observable<IExamList> {
    return this.http.post<IExamList>(EXAM_URL, exam);
  }

  updateExam(exam: IExamCreate): Observable<IExamList> {
    return this.http.put<IExamList>(`${EXAM_URL}/update-status`, { id: exam.id });
  }

  deleteExam(id: string): Observable<void> {
    return this.http.delete<void>(`${EXAM_URL}/single/${id}`);
  }

  public getExamGuests(type?: ExamType) {
    const params: { type: string, programType: ExamType } | { type: string } = type ? { type: 'exam', programType: type } : { type: 'exam' };
    return this.http.get<{ guest: Array<any> }>(EXAMS_GUESTS_API_URL, { params })
      .pipe(
        map(res => res.guest),
        map((allGuest) => allGuest.map(guest => ({ _id: guest._id, user: guest }))), shareReplay(1),
      )
  }

  public getAllNotRegistered(): Observable<Array<unknown>> {
    return this.http.get<{ users: Array<unknown> }>(NOT_REGISTERED_USERS_API_URL, {
      params: {
        type: 'exam',
      }
    }).pipe(
      map(res => res.users),
      map(users => users.map((u: any) => ({ ...u, status: 'notRegistered', user: { cnoNumber: u.cnoNumber, firstName: u.firstName, lastName: u.lastName } }))),
      shareReplay(1),
    );
  }
}
